import req from '../utils/request'

export function logo(query) {
  return req.post('data/logo', query)
}
export function newList(query) {
  return req.post('data/newsList', query)
}
export function banner(query) {
  return req.post('data/banner', query)
}
export function tree(query) {
  return req.post('data/tree', query)
}
export function templatesDetail(query) {
  return req.post('data/templatesDetail', query)
}
export function news(query) {
  return req.post('data/news', query)
}
export function bottomList(query) {
  return req.post('data/bottomList', query)
}
export function getLastNews(query) {
  return req.post('data/lastNews', query)
}
export function getNextNews(query) {
  return req.post('data/nextNews', query)
}
